import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import PurchaseModel from '../model/PurchaseModel.js';
import { map } from 'rxjs/operators';

/**
 * @method apiGetPurchase
 * @method apiRedeemUse
 * @method apiRedeemDetail
 */
export default {
    /**
     * @param {Object} listConfig PurchaseListConfigModel - /service/config/HistoryConfigModel.js
     * @param {Object} filterListConfig PurchaseFilterConfigModel - /service/config/HistoryConfigModel.js
     */
    apiGetPurchase: function (listConfig, filterListConfig) {
        const token = Account.getToken();
        var params = listConfig.getParams();
        if (filterListConfig) {
            var filter = filterListConfig.getParams();
            params = {...params, ...filter};
        }

        const url = ConfigManager.getApiUrl() + '/redeem';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            var purchases = [];
            for (var item of res.data) {
                var purchase = new PurchaseModel (item);
                purchases.push(purchase);
            }
            return purchases;
        }));
    },

    /**
     * @param {String} redeemKey
     */
    apiRedeemUse: function (redeemKey) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + `/redeem/${redeemKey}/use`;
        return BzbsApi.connectBzbsPost(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * @param {String} redeemKey
     */
     apiRedeemDetail: function (redeemKey) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + `/redeem/${redeemKey}`;
        return BzbsApi.connectBzbsPost(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },

}
